// Cart UI utilities

import { getTotalItemCount } from '../utils/calculations';

export function updateCartBadge() {
    const count = getTotalItemCount();
    const badge = document.getElementById('cart-badge');
    const countEl = document.getElementById('cart-count');
    const fabCountEl = document.getElementById('fab-cart-count');

    if (countEl) {
        countEl.textContent = count.toString();
    }

    if (fabCountEl) {
        fabCountEl.textContent = count.toString();
    }

    if (badge && count > 0) {
        badge.classList.add('pulse-animation');
        setTimeout(() => badge.classList.remove('pulse-animation'), 500);
    }
}
